import { useCallback, useEffect, useState } from 'react';
import { distinctUntilChanged } from 'rxjs';

const useObservable = (observable: any) => {
  const [value, setValue] = useState();
  const [error, setError] = useState();

  const listenObservable = useCallback(() => {
    const subscription = observable.pipe(distinctUntilChanged()).subscribe(setValue, setError);
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [observable]);

  useEffect(() => {
    const tempTimeOut = setTimeout(() => {
      listenObservable();
    }, 1);
    return () => {
      clearTimeout(tempTimeOut);
    };
  }, [listenObservable, observable]);

  return [error, value];
};

export default useObservable;
